const DEFAULT_PUBLIC_SITE_URL = 'https://shopexperts.com';

function isHttpUrl(value: URL): boolean {
  return value.protocol === 'http:' || value.protocol === 'https:';
}

function resolvePublicSiteUrl(value: string): URL {
  try {
    const resolved = new URL(value);
    if (isHttpUrl(resolved)) return resolved;
  } catch {}

  return new URL(DEFAULT_PUBLIC_SITE_URL);
}

export function resolveCustomizedPagePreviewLocation(
  profilePreviewUrl: string,
  publicSiteUrl: string,
): { url: string; origin: string } {
  const fallback = resolvePublicSiteUrl(publicSiteUrl);
  let configuredPreview = fallback;

  try {
    const resolvedPreview = new URL(profilePreviewUrl, fallback);
    if (isHttpUrl(resolvedPreview)) configuredPreview = resolvedPreview;
  } catch {}

  const preview = new URL('/blog-section-preview', configuredPreview);
  return { url: preview.toString(), origin: preview.origin };
}
